// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yfah","colBig":"styles_colBig__12fMO","colSmall":"styles_colSmall__cqNYC"};